<template>
  <b-row>
    <b-col md="12">
      <ul class="heading-ul">
        <li>
          <router-link to="/setup/Resources" class="mr-2">
            <i
              class="fa fa-arrow-left"
              aria-hidden="true"
              style="font-size: 18px; color: #262626"
            ></i>
          </router-link>
        </li>
        <li><h3>Currency Details</h3></li>
      </ul>
    </b-col>
    <b-col md="12">
      <b-card class="custome-card mb-0">
        <b-row>
          <b-col md="3">
            <div class="text-center">
              <h4 class="font-weight-light">Resource Code</h4>
              <h4 class="text-uppercase" style="font-weight: 900">
                {{
                  (this.fetchCurrencyView &&
                    this.fetchCurrencyView.response &&
                    this.fetchCurrencyView.response.code) ||
                  ""
                }}
              </h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="text-center">
              <h4 class="font-weight-light">Resource Name</h4>
              <h4 class="text-uppercase" style="font-weight: 900">
                {{
                  (this.fetchCurrencyView &&
                    this.fetchCurrencyView.response &&
                    this.fetchCurrencyView.response.name) ||
                  ""
                }}
              </h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="text-center">
              <h4 class="font-weight-light">Resource Symbol</h4>
              <h4 class="text-uppercase" style="font-weight: 900"></h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="text-center">
              <h4 class="font-weight-light">Last Updated on</h4>
              <h4 class="text-uppercase" style="font-weight: 900">
                {{
                  this.fetchCurrencyView &&
                  this.fetchCurrencyView.response &&
                  this.fetchCurrencyView.response.updatedAt | formatedate
                }}
              </h4>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col md="12" v-if="this.fetchCurrencyView.response.isCurrency">
      <b-card class="custome-card">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="currencyDataShow"
            :fields="currencyViewPage"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            @filtered="onFilter"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="updatedAt" slot-scope="data">
              <div>{{ data.item.updatedAt | formatedate }}</div>
            </template>
            <template slot="empty">
              <div v-if="loading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import Vue from "vue";
import moment from "moment";
export default {
  name: "currencyViewDetail",
  data() {
    return {
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "updatedAt",
      sortDesc: true,
      currencyViewPage: [
        {
          key: "code",
          label: "Currency",
        },
        {
          key: "rate",
          label: "Exchange Rate",
        },
        {
          key: "startDate",
          label: "Effective Start Date",
          formatter: "formateStartdate",
        },
        {
          key: "endDate",
          label: "Effective End Date",
          formatter: "formateStartdate",
        },
      ],
    };
  },
  components: {
    loader,
  },
  computed: {
    ...mapState({
      fetchCurrencyView: (state) => state.currency.fetchCurrencyView,
    }),
    currencyData() {
      return [this.fetchCurrencyView];
    },
    currencyDataShow() {
      let exchangeList = [];
      if (Array.isArray(this.currencyData) && this.currencyData.length > 0) {
        this.currencyData[0]?.response?.exchangeRates?.map((obj) => {
          let arrayObj = {
            endDate: obj.endDate,
            rate: obj.rate,
            code: this.currencyData[0]?.response.code,
            startDate: obj.startDate,
          };
          exchangeList.push(arrayObj);
        });
        return exchangeList;
      } else {
        return [];
      }
    },
  },
  methods: {
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    formateStartdate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch(
      "currency/fetchCurrencyDetail",
      this.$route.params.id
    );
    this.loading = false;
  },
};
</script>
<style scoped>
.heading-ul {
  padding: 0;
}
.heading-ul li {
  list-style: outside none;
  display: inline-block;
  margin-right: 10px;
}
</style>
